import React from 'react';
import { Modal, Checkbox } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

const DeleteConfirmation = ({ open, onConfirm, onCancel, questionName, removeFromAssignedStudents, setRemoveFromAssignedStudents }) => {
  return (
    <Modal
      title="Confirm Deletion"
      open={open}
      onOk={() => onConfirm(removeFromAssignedStudents)} // Pass removeFromAssignedStudents to onConfirm
      onCancel={onCancel}
      okText="Delete"
      cancelText="Cancel"
      style={{ backgroundColor: '#ffffff' }}
    >
      <p>
        Are you sure you want to delete the following lab question?
      </p>
      <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
        <DeleteOutlined style={{ color: '#E96358', fontSize: '17px', marginRight: '8px' }} />
        <span style={{ fontSize: '16px', fontWeight: 'bold' }}>{questionName}</span>
      </div>
      <Checkbox
        style={{ marginTop: '10px' }}
        checked={removeFromAssignedStudents}
        onChange={(e) => setRemoveFromAssignedStudents(e.target.checked)}
      >
        Remove lab question from assigned students only.
      </Checkbox>
    </Modal>
  );
};

export default DeleteConfirmation;
